import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Collapse, Grid, Tooltip, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";

const CollapsibleList = ({ isOpen, items, label }) => {
  const navigate = useNavigate();

  // Function to parse items, clean text, and remove "Bookmark this Case"
  const formattedItems = items?.flat(1)?.map((item) => {
    try {
      const parsedItem = JSON.parse(item);
      let citation = parsedItem?.Citation_Name || item;
      return citation.replace("Bookmark this Case", "").trim(); // Remove "Bookmark this Case"
    } catch (error) {
      return item; // If not JSON, return as is
    }
  });

  // Function to extract the year from the citation
  const extractYear = (text) => {
    const match = text?.match(/\b(19|20)\d{2}\b/); // Match years like 1992, 2023, 2000
    return match ? parseInt(match[0], 10) : -Infinity; // Default to -Infinity if no year found
  };

  // Sort items: Latest year first (descending order)
  const sortedItems = [...formattedItems]
    .flat(1)
    .sort((a, b) => extractYear(b) - extractYear(a));

  return (
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <Box sx={{ mt: 1, pt: 1, borderTop: "1px solid rgba(0, 0, 0, 0.06)" }}>
        {formattedItems?.length > 0 ? (
          <Grid container spacing={0.5}>
            {sortedItems.map((item, index) => (
              <Grid item xs={12} key={index}>
                <Box
                  sx={{
                    p: 0.75,
                    borderRadius: "6px",
                    backgroundColor: "rgba(124, 58, 237, 0.03)",
                    border: "1px solid rgba(124, 58, 237, 0.1)",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "rgba(124, 58, 237, 0.05)",
                      transform: "translateY(-1px)",
                      boxShadow: "0 2px 4px rgba(124, 58, 237, 0.1)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 0.75,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "18px",
                        height: "18px",
                        borderRadius: "4px",
                        backgroundColor: "rgba(124, 58, 237, 0.1)",
                        transition: "all 0.2s ease",
                        flexShrink: 0,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faBook}
                        style={{
                          fontSize: "0.65rem",
                          color: "#7C3AED",
                        }}
                      />
                    </Box>
                    <Box>
                      <Tooltip title="View details" arrow placement="right-end">
                        <Typography
                          sx={{
                            // width: { xs: "80%", md: "fit-content" },
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#5B21B6",
                            mb: 0.25,
                            // whiteSpace: "nowrap",
                            // overflow: "hidden",
                            // textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (label === "cases") {
                              // Handle case-specific navigation
                              navigate("/app/searchResults", {
                                state: {
                                  searchQuery: item.replace(
                                    "Citation Name: ",
                                    ""
                                  ),
                                },
                              });
                            } else {
                              // Handle statute-specific navigation
                              navigate("/app/statute-search", {
                                state: { searchQuery: item },
                              });
                            }
                          }}
                        >
                          {`${index + 1}- ${item}`}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px",
              color: "#303f9f",
            }}
          >
            <Typography fontSize="13px">
              {label === "PDF" ? "No PDF found" : `No relevant ${label} found.`}
            </Typography>
          </Box>
        )}
      </Box>
    </Collapse>
  );
};

export default CollapsibleList;
